<form id="formId" [formGroup]="loanForm" class="form modal-optins" (submit)="onSubmit()">
  <!-- <div class="form__row m-b-xs-medium j-content-center m-b-lg-medium" style="position: relative;" [ngClass]="{ inside_coapp: insideCoapp }">
      <div class="amountBlockDiv modal__input default modal__input_big column-xs-85 column-lg-40 input-area__inactive" [ngClass]="{ invalid: showHawaiiError || showMinAmountError || showMaxAmountError || loanForm.controls['amount'].invalid && loanForm.controls['amount'].touched }" (click)="inputItemClick($event)">
          <span class="descBlock amountBlock font-color-gray text-align-center header-option-form">Amount</span
    >
    <input
      id="amount_i"
      type="text"
      class="default header-option-input"
      placeholder=""
      [(ngModel)]="loanInfo.amount"
      maxlength="6"
      (focusout)="focusOutAmount(); toggleNeighbourMessage($event, true)"
      (focus)="toggleNeighbourMessage($event)"
      (input)="onAmountInput($event)"
      formControlName="amount"
    />
    <div
      class="modal__input__message"
      [ngClass]="{ error: showHawaiiError || showMinAmountError || showMaxAmountError || loanForm.controls['amount'].invalid && loanForm.controls['amount'].touched }"
    >
      Loan Amount ({{loanForm.controls['state'].value === 'HI' ? modalPopups.hawaiiMinAmount : modalPopups.loanMinAmount}} to {{modalPopups.loanMaxAmount}})
    </div>
  </div>
  <span class="modal__input_optional">Optional</span>
</div> -->
<div
  [ngClass]="{ inside_coapp: insideCoapp }"
  class="font-xs-small font-lg-medium w-100 j-self-center p-b-regular"
>
  <span (click)="showHideFullDev()" class="iconTop icon icon_padlock-grey"></span> Your information is protected, private, and secure.
      </div>
      <div class="form__row">
          <div class="modal__input column-xs-50 column-lg input-area__inactive" (click)="inputItemClick($event)" [ngClass]="{
      invalid: loanForm.controls['firstName'].invalid && loanForm.controls['firstName'].touched
    }">
              <span class="descBlock font-color-gray">First Name</span>
              <input id="firstName_i" type="text" placeholder="" maxlength="30" formControlName="firstName" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)" [(ngModel)]="loanInfo.firstName" required />
              <div class="modal__input__message" [ngClass]="{
                error: loanForm.controls['firstName'].invalid && loanForm.controls['firstName'].touched
              }">
                          Enter legal name as it<br>appears on your ID
                      </div>
          </div>
          <div class="modal__input column-xs-50 column-lg input-area__inactive" (click)="inputItemClick($event)" [ngClass]="{
      invalid: loanForm.controls['secondName'].invalid && loanForm.controls['secondName'].touched
    }">
              <span class="descBlock font-color-gray">Last Name</span>
              <input id="secondName_i" type="text" placeholder="" maxlength="30" formControlName="secondName" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)" [(ngModel)]="loanInfo.lastName" required />
              <div class="modal__input__message" [ngClass]="{
                error: loanForm.controls['secondName'].invalid && loanForm.controls['secondName'].touched
              }">
                          Enter legal name as it<br>appears on your ID
                      </div>
          </div>
      </div>
      <div class="form__row">
          <googlemaps-wrapper controlName="address" (inputItemClickEvent)="inputItemClick($event)"  (focusToggleNeighbourMessage)="toggleNeighbourMessage($event)"
            (focusoutToggleNeighbourMessage)="toggleNeighbourMessage($event, true)"
            (onAddressChange)="autoCompleteOnChange($event)" [formGroup]="loanForm"  >
           </googlemaps-wrapper>



     <!--      <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)"
            [ngClass]="{ invalid: loanForm.controls['address'].invalid && loanForm.controls['address'].touched }">
            <span class="descBlock font-color-gray">Address</span>
            <input ngx-google-places-autocomplete id="addressInput" [options]="placesOptions" placeholder="" #places="ngx-places"
              formControlName="address" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)"
              [(ngModel)]="loanInfo.address.address1" (onAddressChange)="autoCompleteOnChange($event)" />
            <div class="modal__input__message" [ngClass]="{
                          error: loanForm.controls['address'].invalid && loanForm.controls['address'].touched
                        }"> Please enter your full street address.
            </div>
          </div> -->
      </div>
      <div class="form__row">
          <div class="modal__input column-xs-35 column-lg-50 input-area__inactive" (click)="inputItemClick($event)" [ngClass]="{ invalid: loanForm.controls['city'].invalid && loanForm.controls['city'].touched }">
              <span class="descBlock font-color-gray">City</span>
              <input id="cityInput" type="text" placeholder="" maxlength="30" formControlName="city" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)" [(ngModel)]="loanInfo.address.city" required />
              <div class="modal__input__message" [ngClass]="{
                error: loanForm.controls['city'].invalid && loanForm.controls['city'].touched
              }">
                          Please Enter Your City
                      </div>
          </div>
          <div id="stateDiv" class="stateDiv modal__input column-xs-35 column-lg-25" [class.input-area__inactive]="!loanForm.controls['state'].value" [class.input-area__active]="loanForm.controls['state'].value" [ngClass]="{ invalid: loanForm.controls['state'].invalid && loanForm.controls['state'].touched}">
              <span class="descBlock font-color-gray">State</span>
              <select id="stateOptionSmall" *ngIf="breakpoints.small || breakpoints.extraSmall" formControlName="state" (change)="changeState($event)" required>
      <option value="" disabled></option>
      <option *ngFor="let state of states" [value]="state.abbreviation">{{ state.abbreviation }}</option>
    </select>
              <select id="stateOptionLarge" *ngIf="breakpoints.large || breakpoints.extraLarge" formControlName="state" (change)="changeState($event)" required>
      <option value="" disabled></option>
      <option *ngFor="let state of states" [value]="state.abbreviation">
        {{ state.name.length < 18 ? state.name : state.abbreviation }}
      </option>
    </select>
          </div>
          <div class="modal__input column-xs-30 column-lg-25 input-area__inactive" (click)="inputItemClick($event)" [ngClass]="{ invalid: loanForm.controls['zipCode'].invalid && loanForm.controls['zipCode'].touched }">
              <span class="descBlock font-color-gray">Zip Code</span>
              <input id="zipCodeInput" type="text" placeholder="" maxlength="12" formControlName="zipCode" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)" [(ngModel)]="loanInfo.address.zipCode" maxlength="5" required />
              <div class="modal__input__message" [ngClass]="{
                error: loanForm.controls['zipCode'].invalid && loanForm.controls['zipCode'].touched
              }">
                          5-digit Zip
                      </div>
          </div>
      </div>
      <div class="form__row">
          <!-- <div class="input-area__inactive modal__input column-xs-50 column-lg" style="max-width: 50%;" (click)='inputItemClick($event)' [ngClass]="{'invalid': (loanForm.controls['socNumber'].invalid && loanForm.controls['socNumber'].touched)}"> -->
          <div class="ssnBlock subnput-area__inactive modal__input column-xs-50 column-lg" (click)="inputItemClickSSN($event)" style="max-width: 50%" [ngClass]="{
      invalid: loanForm.controls['socNumber'].invalid && loanForm.controls['socNumber'].touched
    }">
              <span class="descBlock font-color-gray">
      <span
        class="boxIconInactive boxIconInfoProtectedForm icon icon_ico-lock icon_small m-r-lg-regular"
        style="padding: 0rem; width: 1rem; height: 1rem"
      ></span
      >9-digit Soc. Sec. #
    </span>
              <div class="ssnBlock ssnBoxDiv flex-xs-row column-xs-100 font-xs-smaller font-lg-regular-big font-color-white m-t-xs-medium mob_info_bottom mr-top-none" style="font-weight: 500">
                  <span class="boxIconInfoProtectedForm icon icon_ico-lock icon_small m-r-lg-regular"></span>
                  <span style="visibility: collapse" class="xxxPrefix prefix-protection" matPrefix></span>
                  <input class="socSecNumberInput" (input)="onSSNInput($event)" style="margin-top: 0rem" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)" matInput type="text" id="ssnInputId" placeholder="" formControlName="socNumber"
                      [(ngModel)]="loanInfo.ssn" required maxlength="11" />
              </div>
              <div class="modal__input__message" [ngClass]="{
        error: loanForm.controls['socNumber'].invalid && loanForm.controls['socNumber'].touched
      }">
                  Please enter 9 digit SSN#
              </div>
          </div>
          <div class="dobDiv modal__input column-xs-50 column-lg input-area__inactive" (click)="inputItemClick($event)" [ngClass]="{
      invalid: loanForm.controls['dateOfBirth'].invalid && loanForm.controls['dateOfBirth'].touched
    }">
              <span class="descBlock font-color-gray">Date of Birth</span>
              <input type="text" id="dobInputId" placeholder="" maxlength="10" (input)="onDateInput($event)" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)" formControlName="dateOfBirth" [(ngModel)]="loanInfo.dateOfBirth" maxlength="10"
                  required />
              <div class="modal__input__message" [ngClass]="{
        error: loanForm.controls['dateOfBirth'].invalid && loanForm.controls['dateOfBirth'].touched
      }">
                  Enter MM/DD/YYYY
              </div>
          </div>
      </div>
      <div class="form__row">
          <div class="mobPhoneBlock modal__input column-xs-50 column-lg input-area__inactive" (click)="inputItemClick($event)" [ngClass]="{ invalid: loanForm.controls['mobile'].invalid && loanForm.controls['mobile'].touched }">
              <span class="descBlock font-color-gray">Mobile #</span>
              <input id="mobileInputId" type="text" placeholder="" maxlength="12" (input)="onMobileInput($event)" formControlName="mobile" (focus)="toggleNeighbourMessage($event)" (focusout)="toggleNeighbourMessage($event, true)" [(ngModel)]="loanInfo.mobile" required />
              <div class="modal__input__message" [ngClass]="{
                error: loanForm.controls['mobile'].invalid && loanForm.controls['mobile'].touched
              }">
                          Enter Mobile #
                      </div>
          </div>
          <div class="incomeBlock incomeDiv modal__input column-xs-50 column-lg input-area__inactive" (click)="inputItemClick($event)" [ngClass]="{ invalid: loanForm.controls['income'].invalid && loanForm.controls['income'].touched }">
              <span class="descBlock font-color-gray">Annual Income</span>
              <input id="incomeInputId" type="text" (focus)="toggleNeighbourMessage($event)" (focusout)="focusOutIncome(); toggleNeighbourMessage($event)" placeholder="" maxlength="20" (input)="onIncomeInput($event)" formControlName="income" [(ngModel)]="loanInfo.annualIncome" required />
              <div class="modal__input__message" [ngClass]="{
                error: loanForm.controls['income'].invalid && loanForm.controls['income'].touched
              }">
                          Alimony, child support or separate maintenance income need not be included unless relied upon for credit
                      </div>
          </div>
      </div>
      <div class="form__row form__wrap p-l-lg-medium-big font-xs-small">
          <label class="agreedBoxLabel checkbox column-100">
    <span class="checkbox__input">
      <input type="checkbox" name="checkbox" [(ngModel)]="loanInfo.authorizeText"  formControlName="cb" ngControl="cb" />
      <span class="checkbox__control"> </span>
    </span>
    <span class="radio__label">I have read and agree to the:</span>
  </label>
          <ul id="linkList" class="column-100 link__list">
              <li>
                  <a id="termOfUseEl" (click)="saveStoreGo('/policies', 'terms')" href="javascript:void(0)" class="link">Terms Of Use</a
      >
    </li>
    <li class="mobRightBorder">
      <a
        (click)="saveStoreGo('/policies', 'electronic_communications')"
        href="javascript:void(0)"
        class="link"
        >Electronic Communications</a
      >
    </li>
    <li>
      <a (click)="saveStoreGo('/policies', 'policy')" href="javascript:void(0)" class="link"
        >Privacy Policy</a
      >
    </li>
    <li class="mobRightBorder desktopBorder">
      <a
        (click)="saveStoreGo('/policies', 'credit_pull_authorization')"
        href="javascript:void(0)"
        class="link"
        >Credit Pull Authorization</a
      >
    </li>
  </ul>

  <select *ngIf="FULL_DEV && !hideFullDev" id="devSubStatus">
    <option value="" disabled>SubStatus</option>
    <option *ngFor="let status of substatuses" [value]="status">{{ status }}</option>
  </select>
</div>
<div class="form__row j-content-center m-t-auto">
  <!-- <input *ngIf="!insideCoapp" class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn" type="submit" value="Check Options" [disabled]="!FULL_DEV && loanForm.invalid">
      <input *ngIf="!insideCoapp" class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn" type="button" value="Check Options" [disabled]="!FULL_DEV && loanForm.invalid"> -->
  <button
    id="submitBtn"
    *ngIf="!insideCoapp"
    class="btn btn-size_normal btn-size_normal_next btn-primary font-lg-medium-big CheckOptionsFormBtn"
    [disabled]="(!FULL_DEV && loanForm.invalid)"
  >
    Next
  </button>
  <!-- <input *ngIf="insideCoapp && !breakpoints.extraSmall " class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn" type="submit" value="Submit" [disabled]="!FULL_DEV && loanForm.invalid"> -->
  <button
    id="submitBtn"
    *ngIf="insideCoapp && !breakpoints.extraSmall"
    class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
    [disabled]="!FULL_DEV && loanForm.invalid"
  >
    Submit
  </button>
  <!-- <input *ngIf="insideCoapp && breakpoints.extraSmall" class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn" type="submit" value="Check Options" [disabled]="!FULL_DEV && loanForm.invalid"> -->
  <button
    id="submitBtn"
    *ngIf="insideCoapp && breakpoints.extraSmall"
    class="btn btn-size_normal btn-size_normal_next btn-primary font-lg-medium-big CheckOptionsFormBtn"
    [disabled]="!FULL_DEV && loanForm.invalid"
  >
    Next
  </button>
</div>
<app-hoover-popup
  [isCoapp]="insideCoapp"
  [isMobile]="breakpoints.extraSmall"
  [text]="hooverPopupText"
  [type]="'modal'"
  [additionalClasses]="'wide align-bottom-center font-weight-bold hooverPopupInsideCoapp'"
  class="hover-content"
  (closed)="onClosed($event)"
  *ngIf="showHooverMenu"
>
</app-hoover-popup>
<div *ngIf="!insideCoapp" class="form__row j-content-center m-b-xs-medium">
  <div class="wbIssued font-xs-small font-lg-small m-t-small">
    All loans issued by <span class="font-icon font-icon_webbank-color"></span>
  </div>
</div>
<div *ngIf="insideCoapp" class="coappLoansBottom form__row j-content-center m-b-xs-medium">
  <div class="allLoansLow font-xs-small font-lg-small m-t-small">
    All loans issued by
    <span class="wbIssuedlowWebbankIcon font-icon font-icon_webbank-color small"></span>
  </div>
</div>
<div *ngIf="insideCoapp" class="checkingOptionsRow form__row j-content-center m-b-xs-medium">
  <div
    class="checkingOptionsBottom d-flex a-items-center font-xs-small font-lg-regular m-b-xs-medium m-b-lg-medium"
    style="position: relative"
  >
    <span> Checking your options won’t affect your credit score.</span>
    <!-- <span class="icon icon_small icon_gray icon_info-orange" ></span> -->
    <span
      class="icon icon_small icon_gray icon_info-orange"
      (click)="onInfoIconTrigger(!showHooverMenu, $event)"
    >
    </span>
  </div>
</div>
</form>